var map = {
	"./christmas-decoration.png": 578,
	"./game-start.png": 966,
	"./level-1.png": 2068,
	"./level-2.png": 2069,
	"./level-3.png": 2070,
	"./xmas-pattern-gifts-balls.png": 2071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2067;